/* Página de favoritos: muestra, en el orden guardado, las tarjetas de los productos de localStorage «vb:favs»
   (IDs de producto que guarda el corazón del carrito). Las tarjetas vienen del servidor dentro de <template>.
   Al quitar uno: guarda, dispara «vb:favs:changed» y repinta. Escucha ese evento y «storage». */
(() => {
  if (window.__vbFavsPage) return;
  window.__vbFavsPage = true;
  const KEY = 'vb:favs';
  const read = () => { try { const v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? [...new Set(v.map(String))] : []; } catch (_) { return []; } };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (_) {}
    document.dispatchEvent(new CustomEvent('vb:favs:changed', { detail: list }));
  };
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const render = (root) => {
    const grid = root.querySelector('[data-vb-favs-grid]');
    const empty = root.querySelector('[data-vb-favs-empty]');
    const src = root.querySelector('[data-vb-favs-src]');
    if (!grid || !src) return;
    const ids = read();
    const want = ids.filter((id) => src.querySelector(`template[data-vb-fav-id="${CSS.escape(id)}"]`));
    // IDs de productos que ya no se venden (borrados o despublicados): fuera, para que el contador del corazón cuadre.
    // Solo si el catálogo vino completo (marca data-vb-favs-complete: página 1 y una sola página).
    if (want.length !== ids.length && src.querySelector('[data-vb-favs-complete]')) {
      try { localStorage.setItem(KEY, JSON.stringify(want)); } catch (_) {}
      document.dispatchEvent(new CustomEvent('vb:favs:changed', { detail: want }));
    }
    const now = [...grid.children].map((li) => li.dataset.vbFavItem);
    if (want.join(',') !== now.join(',')) {
      const keep = new Map([...grid.children].map((li) => [li.dataset.vbFavItem, li]));
      const frag = document.createDocumentFragment();
      want.forEach((id) => {
        frag.append(keep.get(id) || src.querySelector(`template[data-vb-fav-id="${CSS.escape(id)}"]`).content.firstElementChild.cloneNode(true));
      });
      grid.replaceChildren(frag);
    }
    grid.hidden = want.length === 0;
    if (empty) empty.hidden = want.length > 0;
  };

  const all = () => document.querySelectorAll('[data-vb-favs]').forEach(render);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-vb-favs-remove]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.vbFavsRemove;
    const li = btn.closest('[data-vb-fav-item]');
    const root = btn.closest('[data-vb-favs]');
    if (btn.dataset.leaving) return; // doble clic sobre la misma tarjeta
    btn.dataset.leaving = '1';
    // El foco pasa a la tarjeta siguiente (o a la anterior / al botón del estado vacío)
    const sib = li && (li.nextElementSibling || li.previousElementSibling);
    const done = () => {
      write(read().filter((x) => x !== id)); // se lee al escribir: dos quitas seguidas no se pisan
      if (root) render(root); // repintar ya: mover nodos en el DOM les quita el foco
      const target = sib && sib.isConnected ? sib.querySelector('[data-vb-favs-remove]') : root?.querySelector('[data-vb-favs-empty] a, [data-vb-favs-empty] h2');
      if (target) { if (!target.matches('a, button')) target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
    };
    btn.classList.add('is-off');
    if (li && !reduce() && !document.hidden) {
      li.classList.add('is-leaving');
      setTimeout(done, 250);
    } else done();
  });

  document.addEventListener('vb:favs:changed', () => requestAnimationFrame(all));
  window.addEventListener('storage', (e) => { if (e.key === KEY || e.key === null) all(); });
  window.addEventListener('pageshow', (e) => { if (e.persisted) all(); });
  document.addEventListener('shopify:section:load', (e) => { const r = e.target.querySelector('[data-vb-favs]'); if (r) render(r); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
})();
